import { useTranslation } from 'next-i18next';
import React from 'react';

const Course = () => {
  const { t } = useTranslation(['whyWukong']);

  return (
    <div className="h-[210px] rounded-[34px] bg-[#F5F5FC] bg-[url(https://cdnwukong.com/images/growth/official/study_plan_course_bg_small.png)] bg-cover bg-center bg-no-repeat lg:mt-[32px] lg:h-[471px] lg:rounded-[36px] lg:bg-[url(https://cdnwukong.com/images/growth/official/study_plan_course_bg.png)] lg:p-[124px] xl:mt-[48px] xl:h-[670px] xl:rounded-[36px] xl:bg-[url(https://cdnwukong.com/images/growth/official/study_plan_course_bg.png)] xl:p-[179px]">
      <div className="relative top-[180px] rounded-[24px] bg-white  p-[24px] shadow-[0px_8px_30px_0px_rgba(0,0,0,0.06)] lg:top-0 lg:w-[510px] lg:bg-transparent lg:p-0 lg:shadow-none xl:top-0 xl:w-[510px] xl:bg-transparent xl:p-0 xl:shadow-none">
        <h3 className="text-[20px] font-semibold text-wk-words-1 lg:text-[28px] xl:text-[34px]">
          {t('备受孩子喜爱的课程设计')}
        </h3>
        <p
          dangerouslySetInnerHTML={{ __html: t('课程设计描述') as string }}
          className="mt-[16px] text-[16px] text-wk-words-2 lg:text-[20px] xl:mt-[24px] xl:text-[28px]"
        />
      </div>
    </div>
  );
};

export default Course;
